import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';

export default class BackgroundImageAPI {
    public static async getAll() {
        let backgroundImages;

        try {
            backgroundImages = await ApiController.get(ApiRoutes.backgroundImage.getAll);
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(backgroundImages);
    }

    public static async createNew(formData: FormData) {
        try {
            const backgroundImage = await ApiController.post(ApiRoutes.backgroundImage.create, formData);
            return Promise.resolve(backgroundImage);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async delete(backgroundImageId: string) {
        try {
            await ApiController.delete(ApiRoutes.backgroundImage.delete(backgroundImageId));
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve();
    }
}
